import { Injectable } from '@angular/core';
import { PickupLocationModel } from './models/pickup-location.model';
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { RequestData } from 'src/app/common/models/request-data.model';

@Injectable({
  providedIn: 'root'
})

export class PickupLocationService {
  constructor(private http: HttpClient) {}

  getPickupLocationList(): any {
    return this.http.get<any>(environment.baseUrl + "pickup-location-info/get-list");
  }

  // getPickupLocationListExt(staticPayload: { search: { filters: { filter: never[]; scope: { offset: string; limit: number; }; }; sort: { column: string; order: string; }[]; }; }): Observable<any> {
  //   return this.http.post<Response>(
  //     environment.baseUrl + "pickup-location-info/get-list-ext",
  //     staticPayload
  //   );
  // }
  getPickupLocationListExt(requestData:RequestData): Observable<any> {

   
    return this.http.post(environment.wsPhp+'/pickuplocation/get-list', requestData);
  
}

  /**
   *
   * @param pickupInfo
   * Calls the API to delete the record
   */
  delete(pickupInfo: PickupLocationModel): Observable<any> {
    return this.http.get(environment.baseUrl + "pickup-location-info/option-in-use?id=" + pickupInfo.id);

  }

  getId(id: number): Observable<any> {
    return this.http.get(environment.baseUrl + "pickup-location-info/get?id=" + id);
    
  }
  /**
   *
   * @param userInfo
   * Calls the update API to insert/update the record
   */
  update(requestParams: any) {
    return this.http.post(
      environment.baseUrl + "pickup-location-info/save",
      requestParams
    );
  }
  
  
  downloadExcel(requestData: any): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
   // const url = 'http://yourdomain.com/api/customers/export'; // Adjust URL

    return this.http.post(environment.wsPhp + '/pickuplocation/export', requestData, { headers, responseType: 'blob' })
      .pipe(
        //catchError(this.handleError)
      );

  }

}


